import { Typography } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { addDays, isBefore } from 'date-fns';
import Date from 'components/date';

const PlanExpiration = ({ endDate }) => {
  if (!endDate) {
    return null;
  }

  const now = new window.Date();
  const expired = isBefore(endDate, now);
  const expiringSoon = !expired && isBefore(endDate, addDays(now, 7));

  if (expired) {
    return (
      <Typography variant="body2" component="div" color="error">
        <FormattedMessage id="plan.expired" /> <Date date={endDate} error />
      </Typography>
    );
  }

  if (expiringSoon) {
    return (
      <Typography variant="body2" component="div" color="warning.main">
        <FormattedMessage id="plan.expiring_soon" /> <Date date={endDate} warning />
      </Typography>
    );
  }

  return (
    <Typography variant="body2" component="div">
      <FormattedMessage id="plan.valid_until" /> <Date date={endDate} />
    </Typography>
  );
};

export default PlanExpiration;
